import type { OrgRef } from '@/api/endpoints';

/**
 * 工地按单位分组（CR-076）：单位按 id（开的先后，和公司页一个顺序），组内保持传进来的顺序（服务端按名字排）。
 * 纯函数、不引 store —— `group-sites.test.ts` 要在 node 里直接 import 它（引了 store 就一路引到要 localStorage 的 i18n 初始化）。
 */
export function groupSitesByOrg<T extends { orgId: number; org: OrgRef }>(
  sites: readonly T[],
): Array<{ org: OrgRef; sites: T[] }> {
  const groups = new Map<number, { org: OrgRef; sites: T[] }>();
  for (const site of sites) {
    const group = groups.get(site.orgId) ?? { org: site.org, sites: [] };
    group.sites.push(site);
    groups.set(site.orgId, group);
  }
  return [...groups.values()].sort((a, b) => a.org.id - b.org.id);
}
